import React, { Component } from 'react';
import converter from './Converter';
import {unitApp} from './unitApp'

//Semantic
import 'semantic-ui-css/semantic.min.css';
import {
  Form,
  Divider,
  Popup,
  Icon,
  Input,
  Label,
  Grid,
  Segment,
	Image
} from 'semantic-ui-react';

import imageInfo from '../../../assets/img/info.png';
import './Calculation.css'


class Calculation extends Component{
  constructor(props){
    super(props)
		let {unitTmp, uniqUnit, appUnit} = this.getUnitParams(props)
		let defaultUnitValue = this.getDefaultUnitOptionValue(unitApp, unitTmp, uniqUnit, appUnit)

    this.state = {
      cur: this.props.currency,
      uniqUnit: null,
      previousUnitValue: null,
			selectedUnit: this.props.preentry == undefined || this.props.preentry == null || this.props.preentry == ''
										? defaultUnitValue : this.props.preentry,
      unitDefault: null,
      unitApp: unitApp,
			inputValue: this.props.value,
			groupid: this.props.groupid,
			order: this.props.order,
			operandID: this.props.operandID,
			unitSend: this.props.unitSend,
			information: this.props.information,
			condition: this.props.condition,
			formula: this.props.formula,
			text: this.props.text,
			unit: this.props.unit,
			raz: this.props.raz,
			unitTmp: '',
			uniqUnit: '',
			appUnit: '',
			unitTmp: unitTmp,
			uniqUnit: uniqUnit,
			appUnit: appUnit,
			error: this.props.error
    }

    this.handleFocus = this.handleFocus.bind(this)
		this.handleChange = this.handleChange.bind(this)
    this.handleChangeUnit = this.handleChangeUnit.bind(this)

		let loop = 0
		let loop1 = 0
  }

	componentWillMount() {
		this.updateCalculationData(this.state.inputValue)
	}

  componentWillReceiveProps(nextProps) {
    if(this.props != nextProps){
      //RAZ
      if(this.props.raz != nextProps.raz){
				let {unitTmp, uniqUnit, appUnit} = this.getUnitParams(nextProps)
				let defaultUnitValue = this.getDefaultUnitOptionValue(unitApp, unitTmp, uniqUnit, appUnit)
				let selectedUnit = 	this.props.preentry == undefined || this.props.preentry == null || this.props.preentry == ''
																	? defaultUnitValue : this.props.preentry

        if(nextProps.value === undefined){
          this.setState({
            inputValue: '',
						selectedUnit: selectedUnit,
						error: nextProps.error
          })
					this.updateCalculationData('')
        } else {
          this.setState({
            inputValue: nextProps.value,
						selectedUnit: selectedUnit,
						error: nextProps.error
          })
					this.updateCalculationData(nextProps.value)
        }

      } else { //CALCUL
        this.setState({
          inputValue: nextProps.value,
					error: nextProps.error
        })
      }
    }

  }

	handleFocus(e) {
    this.setState({
      previousUnitValue: e.target.value,
			selectedUnit: e.target.value
    })
  }

	handleChange(e) {
		this.props.onChangeValueCallback(this.props.groupid, this.props.operandID,
																		 this.props.order, e.target.value);
	}

  handleChangeUnit(e) {
    let from
		let fromUnit = this.state.selectedUnit
		let unitTo = e.target.value

		if (e.target.value != fromUnit) {
			Object.entries(this.state.unitApp).map((key, Mainindex) => {
	    	if(e.target.id !== undefined && e.target.id !== '') {
	    		from = e.target.id.split(';')[0]
	      } else {
			    Object.entries(key[1]).map((keys, Mainindex) => {
			      if (keys[1] === e.target.value) {
			      	from = "%%" + key[0] + "%%"
			      }
			    })
	      }
	    })
  	}

		let number = this.state.inputValue;

		if (typeof number === 'string') {
	  	// this is a string
	    number = number.replace(",", ".");
	  }

		if(number === "" || number === undefined){
      number = 0
    }

		let convertedValue = converter(from, number, fromUnit, unitTo)

    this.setState({
      previousUnitValue: unitTo,
			selectedUnit: e.target.value,
			inputValue: convertedValue === 'NaN' ? 0 : convertedValue
    })

		this.updateCalculationUnitData(convertedValue, e.target.value)
  }

	updateCalculationUnitData(resultValue = null, unit = null) {
		let value = {
			value: resultValue === null ? this.state.inputValue : resultValue,
			unit: unit === null ? this.state.selectedUnit : unit
		}

		this.props.onChangeUnitCallback(this.props.groupid, this.props.operandID,
																		this.props.order, value)
	}

	convert(from, number, unitFrom, unitTo) {
		let convertResult = converter(from, number, unitFrom, unitTo)
		this.loop = 1
    this.setState({
      inputValue: convertResult
    })

  	return convertResult
  }

	setPrevious(key) {
		this.loop1 = 1
  	this.setState({
    	previousUnitValue: key,
			selectedUnit: key
   	})
  }

	getUnitParams(props) {
		let unitTmp, uniqUnit, appUnit, unitParams
    if (props.unit != undefined) {
      unitTmp = props.unit.replace(new RegExp("%%", 'g'), '').split(';')

    if (props.userUnit === "Meter") {
        uniqUnit = unitTmp[2]
    } else if (props.userUnit === null){
        uniqUnit = unitTmp[2]
    } else {
        uniqUnit = unitTmp[3]
    }

    if (props.unitSend != null) {
        uniqUnit = props.unitSend
    }

      appUnit = unitTmp[1]
    }

		unitParams = {
			unitTmp: unitTmp,
			uniqUnit: uniqUnit,
			unitParams: unitParams
		}

		return unitParams
	}

	updateCalculationData(inputValue) {
		let value = {
			operandID: this.state.operandID,
			groupid: this.state.groupid,
			order: this.state.order,
			value: inputValue,
			condition: this.state.condition,
			formula: this.state.formula,
			selectedUnit: this.state.selectedUnit,
			unitApp: this.state.unit,
			raz: this.state.raz,
			text: this.state.text
		}

		this.props.onChangeValueCallback(this.props.groupid, this.props.operandID,
																		this.props.order, value)
	}

	createUnitOptionsTags() {
		let optionIndex = 0
		let unitOptionsTags = []

		Object.entries(this.state.unitApp).map((unitAppItem, Mainindex) => {
			if (unitAppItem[0] === this.state.unitTmp[0]) {
				Object.entries(unitAppItem[1]).map((unitItem, unitItemIndex) => {
					unitOptionsTags.push(<option key={unitItemIndex} value={unitItem[1]}>{unitItem[1]}</option>)
				})
			}
		})

		return unitOptionsTags;
	}

	getDefaultUnitOptionValue(unitAppParam, unitTmp, uniqUnit, appUnit) {
		let optionIndex = 0
		let defaultUnitItem

		Object.entries(unitAppParam).map((unitAppItem, Mainindex) => {
			if (unitTmp != undefined && unitAppItem[0] === unitTmp[0]) {
				Object.entries(unitAppItem[1]).map((unitItem, unitItemIndex) => {
					if (uniqUnit != undefined && uniqUnit === unitItem[1]) {
						defaultUnitItem = unitItem[1]
					}
				})
			}
		})

		return defaultUnitItem;
	}

  createInputTag() {
		return (
      <input className="result-input"
				order={this.state.order} groupid={this.state.groupid}
        text={this.state.text} value={this.state.inputValue}
				variable={this.state.variable}
        unitapp={this.state.unit}
				onChange={this.handleChange}
        readOnly
      />
    )
  }

  createinputTagWithLabel(label, position) {
    return (
      <Input order={this.props.order} groupid={this.state.groupid}
        value={this.state.inputValue}
        text={this.state.text} variable={this.state.variable}
        unitapp={this.state.unit}
        label={{ basic: true, content: label }}
        labelPosition={position}
				className='result-input'
        readOnly
      />
    )
  }

  render () {

		// this.updateCalculationData();

    return (
      <Grid columns={2} style={this.props.isHidden ? {display: 'none'} : null} >
        {/* Description of calculation result*/}
        <Grid.Row className='description-row'>
          <Grid.Column textAlign='left' verticalAlign='middle' width={16}>
            <Label title={this.props.information} className='description-title-label'>
              {this.props.text}
            </Label>

						<Label className='description-info-label'>
							{this.props.information != undefined ? (
								<Popup
                  id="popupInfos"
                  content={this.props.information}
									trigger = {
										<Image src={imageInfo} size='mini' verticalAlign='middle'
											className='description-info-image' />
									}

								/>
							) : (
								<div></div>
							)}
						</Label>
          </Grid.Column>
        </Grid.Row>

        {/* Value of calculation result*/}
        <Grid.Row className='result-row'>
          <Grid.Column textAlign="left" verticalAlign="middle"
						className="result-value-column" width={16}>

            <div className='result-content'>
              {/* Value */}
              <div>
                { this.createInputTag() }
              </div>

              {/* Unit */}
              {
                this.state.unitTmp === undefined ? (
                  <div></div>
                ):(
                  this.state.unitTmp[0] === "cur" ? (
                    <div className="result-currency-content">
                      <label className="result-currency-label">
                        {this.state.cur}
                      </label>
                    </div>
                  ):(
                    this.state.unitTmp[1] === undefined ? (
                      <div className="result-none-content">
                        <label className="result-none-label">
                          {this.state.unitTmp[0]}
                        </label>
                      </div>
                    ):(
                      <div className="result-unit-content">
                        <select className="result-unit-select"
													variable={this.props.variable}
													value={this.state.selectedUnit}
													onFocus={this.handleFocus}
                          onChange={this.handleChangeUnit}>
													{ this.createUnitOptionsTags() }
                        </select>
                      </div>
                    ) //unitTmp[1] === undefined
                  ) // unitTmp[0] === "cur"
                ) // unitTmp === undefined
              }
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

export default Calculation;



// WEBPACK FOOTER //
// ./src/components/Protected/Travaux/Calculation.jsx